<template>
	<div class="ce-anchor-element">
		<a :id="objectdata.cssID[0]"></a>
		<div
			v-if="objectdata.showheadline"
			v-html="getHeadline(objectdata.headline.unit, objectdata.headline.value)"
		></div>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {
			// this.init();
		},
		methods: {
			scrollToAnchor() {
				// animate anchor-links
				// if (window.location.hash) {
				// 	setTimeout(function() {
				// 		var hash = window.location.hash.substring(1);
				// 		var space = 50;
				// 		if ($(window).width > 1623) {
				// 			space = 80;
				// 		}
				// 		if ($("#" + hash).length === 1) {
				// 			$("html,body").animate(
				// 				{
				// 					scrollTop: $("#" + hash).offset().top - space
				// 				},
				// 				{
				// 					duration: "slow"
				// 					// complete: function() {
				// 					// }
				// 				}
				// 			);
				// 		}
				// 	}, 500);
				// }
			}
		},
		composed: {
			getfullheadline() {
				return;
			}
		}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";

	h1,
	h2,
	h3 {
		display: block;
		padding: 0;
		text-align: center;
		margin: 0 0 40px;
		&:after {
			border-width: 0;
		}
	}
</style>